import React from "react";
import cn from "classnames";
import styles from "./Tooltip.module.sass";
import Icon from "../Icon";

const Tooltip = ({ className, title, icon, place }) => {
	return (
		<div className={cn(styles.tooltip, className)}>
			<Icon name={icon} />
			<span className={styles.tooltiptext}>{title}</span>
		</div>
	);
};

export default Tooltip;
